const selector = '#header-component details.vap-locale-selector';

function closeSelector(details, restoreFocus = false) {
  if (!(details instanceof HTMLDetailsElement)) return;
  details.removeAttribute('open');
  if (restoreFocus) details.querySelector('summary')?.focus();
}

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openSelector = document.querySelector(`${selector}[open]`);
  if (!(openSelector instanceof HTMLDetailsElement)) return;
  event.preventDefault();
  closeSelector(openSelector, true);
});

document.addEventListener('pointerdown', (event) => {
  document.querySelectorAll(`${selector}[open]`).forEach((details) => {
    if (event.target instanceof Node && !details.contains(event.target)) {
      closeSelector(details);
    }
  });
});

const desktopMedia = window.matchMedia('(min-width: 750px)');
desktopMedia.addEventListener('change', (event) => {
  if (event.matches) return;
  document.querySelectorAll(`${selector}[open]`).forEach((details) => closeSelector(details));
});
